import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faBuildingColumns, faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function UniversityPicker({ onSelect }) {
  const [universities, setUniversities] = useState(null);
  const [selected, setSelected] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/api/active_universities', {
      headers: { Accept: 'application/vnd.howdy.active-universities+json' },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((list) => {
        const arr = Array.isArray(list) ? list : [];
        setUniversities(arr);
        if (arr.length > 0) setSelected(arr[0].university_id);
      })
      .catch((err) => setError(err.message));
  }, []);

  if (error) {
    return (
      <Container className="py-5" style={{ maxWidth: '480px' }}>
        <Alert variant="danger">Failed to load universities: {error}</Alert>
      </Container>
    );
  }

  if (!universities) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status" />
      </Container>
    );
  }

  const handleContinue = () => {
    const u = universities.find((x) => x.university_id === selected);
    if (u) onSelect(u);
  };

  return (
    <Container
      className="d-flex flex-column justify-content-center align-items-center py-5"
      style={{ minHeight: '100vh', maxWidth: '480px' }}
    >
      <Card
        className="w-100 border-0 shadow"
        style={{ backgroundColor: '#ffffff', borderRadius: '12px' }}
      >
        <Card.Body className="p-4 p-md-5">
          <div className="text-center mb-4">
            <FontAwesomeIcon
              icon={faBuildingColumns}
              className="text-primary mb-3"
              style={{ fontSize: '2.25rem' }}
            />
            <h1
              className="fw-bold mb-1"
              style={{ fontFamily: 'Georgia, "Times New Roman", serif', fontSize: '1.75rem' }}
            >
              Welcome
            </h1>
            <p className="text-muted mb-0">Choose a university to continue.</p>
          </div>
          {universities.length === 0 ? (
            <Alert variant="info" className="mb-0">No active universities available.</Alert>
          ) : (
            <>
              <Form.Group className="mb-4">
                <Form.Label
                  className="fw-bold text-uppercase text-muted mb-2"
                  style={{ letterSpacing: '0.06em', fontSize: '0.72rem' }}
                >
                  University
                </Form.Label>
                <Form.Select
                  size="lg"
                  value={selected}
                  onChange={(e) => setSelected(e.target.value)}
                  aria-label="University"
                >
                  {universities.map((u) => (
                    <option key={u.university_id} value={u.university_id}>
                      {u.university_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <div className="d-grid mb-3">
                <Button size="lg" variant="primary" onClick={handleContinue} disabled={!selected}>
                  View course report <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
      <div className="mt-3">
        <a
          href="/logout"
          className="text-muted text-decoration-none small"
        >
          <FontAwesomeIcon icon={faRightFromBracket} className="me-1" />
          Sign out
        </a>
      </div>
    </Container>
  );
}
